import { render, staticRenderFns } from "./ques.vue?vue&type=template&id=e562b460&scoped=true&"
import script from "./ques.vue?vue&type=script&lang=js&"
export * from "./ques.vue?vue&type=script&lang=js&"
import style0 from "./ques.vue?vue&type=style&index=0&id=e562b460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e562b460",
  null
  
)

export default component.exports